import { useSelector } from 'react-redux';
import { getModulePrivs } from '../redux/selectors/modules';
import { useGruser } from './useGruser';
export default function(moduleId) {
    const { gruser } = useGruser();
    const modulePrivs = useSelector((state)=>getModulePrivs(state, gruser, moduleId));
    return modulePrivs;
}
